import React from 'react';
import { IconProps } from '../types';
const MinecraftTippedArrowHead: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="12" y="2" width="1" height="1" fill="rgba(217, 217, 217, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="14" y="2" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(192, 192, 192, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(241, 241, 241, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(247, 247, 247, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(217, 217, 217, 255)" />
<rect x="14" y="3" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(192, 192, 192, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(247, 247, 247, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(241, 241, 241, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(247, 247, 247, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(143, 143, 143, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(192, 192, 192, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="0" y="6" width="1" height="1" fill="rgba(217, 217, 217, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(171, 171, 171, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(192, 192, 192, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(241, 241, 241, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(143, 143, 143, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(217, 217, 217, 255)" />
</svg>);
export default MinecraftTippedArrowHead;